/**
 * ecloud-designsystem の toaster を型安全にラップした共通 helper。
 *
 * ecloud v3 の toaster export は実行時に .create() を持つが、型定義が追いついていない
 * ため unknown → AppToaster キャストで解決する。このキャストを 1 箇所に集約し、
 * 各ページ / hook が同じ型エイリアスを重複定義しないようにする。
 */
import { toaster as rawToaster } from '@enechain/ecloud-designsystem'

type AppToaster = {
  create: (options: {
    /** 同じ id の toast が表示中なら、 2 件目を足さず 1 件目を更新する。 省略時は呼ぶたびに別の toast になる。 */
    id?: string
    type?: 'success' | 'error' | 'info' | 'loading' | 'warning'
    title?: string
    description?: string
    /**
     * 自動で閉じるまでの ms。 省略時は chakra toaster の既定 (5000ms)。
     * design 側が duration を指定している toast (= 個人設定の保存 toast は
     * `design/settings.html` line 137-161 で 2500ms) のためだけに渡す。
     */
    duration?: number
    /**
     * 閉じる (×) ボタンを出すか。 省略時は非表示 (DS の ToastComponent は
     * `closable === true` の時だけ CloseTrigger を描画する)。
     */
    closable?: boolean
  }) => string
  /**
   * 表示中の toast を片付ける (id 省略で全件)。 テストの afterEach 用
   * (toaster は module-level singleton の store を持つため、 提出/成功系トーストを
   * 検証したテストの後で片付けないと次のテストに残留する)。
   */
  remove: (id?: string) => void
}

export const appToaster = rawToaster as unknown as AppToaster
